import AcceptCookiesComponent from './components/AcceptCookies';
import AcceptCookiesContainer from './containers/AcceptCookies';

export { getAcceptCookie } from './selectors';

export const AcceptCookies = AcceptCookiesContainer(AcceptCookiesComponent);



// WEBPACK FOOTER //
// ./src/app/acceptCookies/index.js